(function () {
  'use strict';

  var STORAGE_KEY = 'eilipWaitlistAttributionV4';
  var FORM_START_KEY = 'eilipWaitlistFormStartSentV1';
  var FORM_SELECTOR = '[data-loops-waitlist-form]';
  var form = null;

  var PARAMETER_MAP = {
    utm_source: 'SourcePlatform',
    utm_medium: 'TrafficType',
    utm_campaign: 'CampaignName',
    utm_content: 'AdName',
    utm_term: 'AdSetName',
    meta_campaign_id: 'CampaignId',
    meta_adset_id: 'AdSetId',
    meta_ad_id: 'AdId',
    meta_placement: 'Placement',
    placement: 'Placement'
  };

  function emptyState() {
    return {
      first: {},
      latest: {}
    };
  }

  function hasValues(values) {
    return Object.keys(PARAMETER_MAP).some(function (parameter) {
      return Boolean(values && values[PARAMETER_MAP[parameter]]);
    });
  }

  function readState() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        return emptyState();
      }

      var parsed = JSON.parse(stored);

      return {
        first: parsed && parsed.first ? parsed.first : {},
        latest: parsed && parsed.latest ? parsed.latest : {}
      };
    } catch (error) {
      return emptyState();
    }
  }

  function saveState(state) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(state)
      );
    } catch (error) {
      // Continue for the current page if storage is unavailable.
    }
  }

  function deleteState() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Nothing else to do.
    }
  }

  function readUrlAttribution() {
    var params = new URLSearchParams(window.location.search);
    var values = {};

    Object.keys(PARAMETER_MAP).forEach(function (parameter) {
      var value = String(
        params.get(parameter) || ''
      )
        .trim()
        .slice(0, 500);

      if (value) {
        values[PARAMETER_MAP[parameter]] = value;
      }
    });

    if (!hasValues(values)) {
      return {};
    }

    values.LandingPage =
      window.location.origin + window.location.pathname;

    values.VisitDate = new Date().toISOString();

    return values;
  }

  function setField(name, value) {
    if (!form) {
      return;
    }

    var field = form.querySelector(
      '[name="' + name + '"]'
    );

    if (field) {
      field.value = value || '';
    }
  }

  function clearAttributionFields() {
    ['first', 'latest'].forEach(function (prefix) {
      Object.keys(PARAMETER_MAP).forEach(function (parameter) {
        setField(
          prefix + PARAMETER_MAP[parameter],
          ''
        );
      });

      setField(prefix + 'LandingPage', '');
      setField(prefix + 'VisitDate', '');
    });
  }

  function populateFields(state) {
    ['first', 'latest'].forEach(function (prefix) {
      var values = state[prefix] || {};

      Object.keys(PARAMETER_MAP).forEach(function (parameter) {
        var suffix = PARAMETER_MAP[parameter];

        setField(
          prefix + suffix,
          values[suffix]
        );
      });

      setField(
        prefix + 'LandingPage',
        values.LandingPage
      );

      setField(
        prefix + 'VisitDate',
        values.VisitDate
      );
    });
  }

  function privacyApiReady() {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy
        .marketingAllowed === 'function'
    );
  }

  function marketingAllowed() {
    if (!privacyApiReady()) {
      return false;
    }

    return Boolean(
      window.Shopify.customerPrivacy.marketingAllowed()
    );
  }

  function captureAttribution() {
    if (!form) {
      return;
    }

    if (!marketingAllowed()) {
      clearAttributionFields();
      return;
    }

    var current = readUrlAttribution();
    var state = readState();

    if (hasValues(current)) {
      if (!hasValues(state.first)) {
        state.first = current;
      }

      state.latest = current;
      saveState(state);
    }

    populateFields(state);
  }

  function sendWaitlistFormStart() {
    if (!form) {
      return;
    }

    if (!marketingAllowed()) {
      return;
    }

    try {
      if (window.sessionStorage.getItem(FORM_START_KEY) === 'true') {
        return;
      }

      window.sessionStorage.setItem(FORM_START_KEY, 'true');
    } catch (error) {
      // If sessionStorage is unavailable, continue and send once for this page.
    }

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'EILIP_WaitlistFormStart');
      console.log('EILIP_WaitlistFormStart sent');
    } else {
      console.warn('Meta fbq was not available. EILIP_WaitlistFormStart could not be sent from the browser.');
    }
  }

  function attachWaitlistFormStartListener() {
    if (!form) {
      return;
    }

    form.addEventListener(
      'focusin',
      sendWaitlistFormStart,
      true
    );

    form.addEventListener(
      'input',
      sendWaitlistFormStart,
      true
    );

    form.addEventListener(
      'change',
      sendWaitlistFormStart,
      true
    );
  }

  function loadPrivacyApi(attempt) {
    var attemptNumber = attempt || 0;

    if (privacyApiReady()) {
      captureAttribution();
      return;
    }

    if (
      window.Shopify &&
      typeof window.Shopify.loadFeatures === 'function'
    ) {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1'
          }
        ],
        function (error) {
          if (!error && privacyApiReady()) {
            captureAttribution();
          }
        }
      );

      return;
    }

    if (attemptNumber < 20) {
      window.setTimeout(function () {
        loadPrivacyApi(attemptNumber + 1);
      }, 250);
    }
  }

  function initialise() {
    form = document.querySelector(FORM_SELECTOR);

    if (!form) {
      return;
    }

    attachWaitlistFormStartListener();

    document.addEventListener(
      'visitorConsentCollected',
      function (event) {
        var consent =
          event && event.detail
            ? event.detail
            : {};

        if (consent.marketingAllowed) {
          captureAttribution();
        } else {
          deleteState();
          clearAttributionFields();
        }
      }
    );

    loadPrivacyApi(0);

    form.addEventListener(
      'submit',
      function () {
        setField(
          'signupDate',
          new Date().toISOString()
        );

        if (marketingAllowed()) {
          captureAttribution();
        } else {
          clearAttributionFields();
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );
  } else {
    initialise();
  }
})();